// Copy for the unsubscribe page and the "open the app" hand-off page.
//
// Kept as a structured content module (like surveyFeedback.js) because both
// pages are opened straight from an email — the language comes from the `lang`
// query param the email put there, not from the visitor's browser or from the
// site's locale detection.

export const unsubscribeContent = {
  bg: {
    metaTitle: "Отписване | Momfident",
    heading: "Отписване от имейли",
    working: "Обработваме заявката ви…",
    successHeading: "Отписахте се успешно",
    successBody:
      "Няма да получавате повече имейли с напомняния и съвети от Momfident. Важните имейли, свързани с профила ви — потвърждение на имейл, възстановяване на парола — ще продължите да получавате.",
    undoPrompt: "Промених решението си:",
    undoCta: "Абонирай ме отново",
    resubscribedHeading: "Абонирахте се отново",
    resubscribedBody:
      "Отново ще получавате имейли с напомняния и съвети от Momfident.",
    invalidHeading: "Невалидна връзка",
    invalidBody:
      "Тази връзка за отписване е невалидна или непълна. Ако сте я копирали ръчно, опитайте да кликнете директно от имейла.",
    errorHeading: "Нещо се обърка",
    errorBody:
      "Не успяхме да обработим заявката ви. Опитайте отново или ни пишете на contact@momfident.io.",
    retryCta: "Опитай отново",
    homeCta: "Към momfident.io",
  },
  en: {
    metaTitle: "Unsubscribe | Momfident",
    heading: "Unsubscribe from emails",
    working: "Processing your request…",
    successHeading: "You have been unsubscribed",
    successBody:
      "You will no longer receive reminder and tips emails from Momfident. Essential account emails — address verification, password resets — will still reach you.",
    undoPrompt: "Changed your mind?",
    undoCta: "Resubscribe me",
    resubscribedHeading: "You are subscribed again",
    resubscribedBody:
      "You will receive reminder and tips emails from Momfident again.",
    invalidHeading: "Invalid link",
    invalidBody:
      "This unsubscribe link is invalid or incomplete. If you copied it by hand, try clicking it directly from the email instead.",
    errorHeading: "Something went wrong",
    errorBody:
      "We could not process your request. Please try again, or write to us at contact@momfident.io.",
    retryCta: "Try again",
    homeCta: "Go to momfident.io",
  },
};

export const openAppContent = {
  bg: {
    metaTitle: "Отвори Momfident",
    heading: "Отваряме приложението…",
    body: "Ако нищо не се случи след няколко секунди, изтеглете приложението или го отворете ръчно.",
    downloadCta: "Изтегли приложението",
  },
  en: {
    metaTitle: "Open Momfident",
    heading: "Opening the app…",
    body: "If nothing happens after a few seconds, download the app or open it manually.",
    downloadCta: "Download the app",
  },
};
